type ImageRendererProps = {
  url: string
  name: string
  description: string
}

export const ImagePreviewRenderer = (props: ImageRendererProps) => {
  const { url, name, description } = props
  const hasDescription = !!description
  return (
    <figure className="min-h-0 max-h-full grow basis-full flex flex-col justify-center items-center overflow-y-auto">
      <img
        src={url}
        className={`object-contain min-h-[200px] ${
          hasDescription ? 'max-h-[calc(100%-3.7rem)]' : 'max-h-full'
        }`}
        alt={name}
        loading="lazy"
      />

      {hasDescription && (
        <div className="min-h-0 grow-0 w-full">
          <figcaption className="pt-2 px-2 pb-4 text-sm max-w-screen-lg italic mx-auto">
            {description}
          </figcaption>
          <div className="absolute -bottom-1 h-6 w-full bg-gradient-to-t from-surface"></div>
        </div>
      )}
    </figure>
  )
}
